import { useCallback, useEffect, useState } from "react";
import PlotAPI from "../plotAPI";

const useCurrentProjectInfo = () => {
    const [currentProjectToken, setCurrentProjectToken] = useState<null | string>(null); // Token of the current Project being viewed
    const [currentProjectInfo, setCurrentProjectInfo] = useState<null | any>(null); // Project Info of the current Project being viewed

    // Current Project Token Changed?
    useEffect(() => {
        if (currentProjectToken) {
            PlotAPI.getProjectInfo(currentProjectToken).then((response) => {
                setCurrentProjectInfo(response);
            });
        }
    }, [currentProjectToken]);

    /**
     * Reload the current project without reloading the page
     * @returns Boolean indicatinng success of reload
     */
    const reloadCurrentProject = useCallback((): Promise<boolean> => {
        if (currentProjectToken) {
            return PlotAPI.getProjectInfo(currentProjectToken).then((response) => {
                setCurrentProjectInfo(response);

                return true;
            });
        }

        return Promise.resolve(true);
    }, [currentProjectToken]);

    return { currentProjectToken, setCurrentProjectToken, currentProjectInfo, reloadCurrentProject };
};

export default useCurrentProjectInfo;
